module.exports = __webpack_public_path__ + "img/logo_heg.df751e04.png";